import { displayNotification, sendAPIRequest } from "helpers";
import React, { useCallback, useContext, useState } from "react";
import { useEffect } from "react";
import TableElementModifyPreviewModal from "./modals/TableElementModifyPreviewModal";
import { FormDataContext } from "../contexts/FormContext";
import TableBodyPreview from "./TableBodyPreview";
import TableBodyDataentry from "./TableBodyDataentry";
import TableElementModifyDataentryModal from "./modals/TableElementModifyDataentryModal";

const TableElement = (props) => {
    const formDataContext = useContext(FormDataContext);

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        loadColumns();
    }, []);

    const loadColumns = useCallback(async () => {
        try {
            const req = await sendAPIRequest(`/api/pvsa/form-table-columns?form-table-id=${props.tableId}`);
            const res = await req.json();
            if (res.success) {
                setColumns(res.data);
            } else {
                displayNotification("error", "Error loading table columns [B]");
            }
        } catch (e) {
            console.error({ e });
            displayNotification("error", "Error loading table columns [F]");
        }
    }, [props.tableId]);

    return (
        <>
            {columns.length > 0 && (
                <>
                    {props.isReadOnly === false && (
                        <div className="d-flex mb-2">
                            <div className="ms-auto">
                                {formDataContext.mode === "preview" ? (
                                    <TableElementModifyPreviewModal
                                        templateId={props.templateId}
                                        tableId={props.tableId}
                                        columns={columns}
                                    />
                                ) : (
                                    <TableElementModifyDataentryModal
                                        templateId={props.templateId}
                                        tableId={props.tableId}
                                        columns={columns}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th width="10px" className="text-center">
                                        #
                                    </th>
                                    {columns.map((r) => (
                                        <th key={r.id}>{r.name}</th>
                                    ))}
                                    {props.isReadOnly === false && <th width="80px">Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {formDataContext.mode === "preview" ? (
                                    <TableBodyPreview
                                        templateId={props.templateId}
                                        tableId={props.tableId}
                                        columns={columns}
                                        isReadOnly={props.isReadOnly}
                                    />
                                ) : (
                                    <TableBodyDataentry
                                        templateId={props.templateId}
                                        tableId={props.tableId}
                                        columns={columns}
                                        isReadOnly={props.isReadOnly}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

TableElement.defaultProps = {
    templateId: "",
    tableId: "",
    element: {},
    onChange: () => {},
    isReadOnly: false,
};

export default TableElement;
